import React from 'react';
import InstituteCrudPage from './InstituteCrudPage';
import { entityConfigs } from '../../config/entityConfigs';

export default function HomeworkPage() {
  return <InstituteCrudPage config={entityConfigs['homework']} />;
}
